<script setup>
import ProductContentFieldForm from '@frontJs/components/forms/projectManagement/ai/ProductContentFieldForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, aiProductContentField, productAttributes } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    aiProductContentField: {
        type: Object,
        required: false,
    },
    productAttributes: {
        type: Array,
        required: false,
        default: () => [],
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Champ personnalisé - Contenus produits - IA - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - IA - Contenus produits - Champ personnalisé
    </PageTitle>

    <ProductContentFieldForm
        :tenant="tenant"
        :ai-product-content-field="aiProductContentField"
        :product-attributes="productAttributes"
    />
</template>
